import { Platform } from 'react-native';
import styled from 'styled-components/native';

export default styled.View`
  width: 100%;
  padding: 0 15px 50px;
  ${Platform.OS !== 'web' && `margin-top: 40px;`}
`;
